module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Consulta de Projetos de Pesquisa'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.consultar()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nº Registro",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.consulta.numRegistro),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "numRegistro", $$v)
      },
      expression: "consulta.numRegistro"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.consulta.titulo),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "titulo", $$v)
      },
      expression: "consulta.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Palavra-chave",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.consulta.palavraChave),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "palavraChave", $$v)
      },
      expression: "consulta.palavraChave"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Membro da equipe",
      "max-height": "400",
      "clearable": ""
    },
    model: {
      value: (_vm.consulta.membroEquipe),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "membroEquipe", $$v)
      },
      expression: "consulta.membroEquipe"
    }
  })], 1)], 1), _vm._v(" "), (_vm.consultaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Área do Conhecimento",
      "items": _vm.listaAreaDoConhecimento,
      "item-text": "descricao",
      "item-value": "id",
      "clearable": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasAreas(_vm.consulta.areaConhecimento)
      },
      "click:clear": function($event) {
        return _vm.limpaNomeAreaSubarea()
      }
    },
    model: {
      value: (_vm.consulta.areaConhecimento),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "areaConhecimento", $$v)
      },
      expression: "consulta.areaConhecimento"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Área",
      "items": _vm.listaNomeArea,
      "item-text": "descricao",
      "item-value": "id",
      "disabled": _vm.nomeAreaDisabled,
      "clearable": "",
      "autocomplete": ""
    },
    on: {
      "input": function($event) {
        return _vm.getNomesDasSubareas(_vm.consulta.nomeArea)
      },
      "click:clear": function($event) {
        return _vm.limpaNomeSubarea()
      }
    },
    model: {
      value: (_vm.consulta.nomeArea),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "nomeArea", $$v)
      },
      expression: "consulta.nomeArea"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.consultaAvancada) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Nome da Subárea",
      "items": _vm.listaNomeSubarea,
      "item-text": "descricao",
      "item-value": "id",
      "disabled": _vm.nomeSubareaDisabled || _vm.listaNomeSubarea.length === 0,
      "clearable": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.consulta.nomeSubarea),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "nomeSubarea", $$v)
      },
      expression: "consulta.nomeSubarea"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs11": "",
      "sm5": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Linha de Pesquisa no Programa de Pós-Graduação",
      "items": _vm.listaLinhaPesquisaPPG,
      "clearable": "",
      "autocomplete": "",
      "disabled": "",
      "hint": "Esta opção está indisponível no momento.",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.consulta.linhaPesquisaPPG),
      callback: function($$v) {
        _vm.$set(_vm.consulta, "linhaPesquisaPPG", $$v)
      },
      expression: "consulta.linhaPesquisaPPG"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [(!_vm.consultaAvancada) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.abrirConsultaAvancada()
      }
    }
  }, [_vm._v("Consulta avançada")]) : _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.fecharConsultaAvancada()
      }
    }
  }, [_vm._v("Consulta simples")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.limpar()
      }
    }
  }, [_vm._v("Limpar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.consultar()
      }
    }
  }, [_vm._v("Consultar")])], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Resultados da Consulta'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetosPesquisa,
      "search": _vm.search,
      "no-data-text": 'Nenhum projeto encontrado',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "library_books",
            "color": "primary",
            "tooltip": "Visualizar cadastro do projeto"
          },
          on: {
            "click": function($event) {
              return _vm.toAbrirCadastroProjetoPesquisa(props.item.id)
            }
          }
        })]
      }
    }, {
      key: "item.numRegistro",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.numRegistro === null || props.item.numRegistro === '' ? '-' : props.item.numRegistro))]
      }
    }, {
      key: "item.sigla",
      fn: function(props) {
        return [_vm._v(_vm._s(props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla))]
      }
    }, {
      key: "item.dataInicio",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm.dates.format(props.item.dataInicio)))]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetosPesquisa.length) + " " + _vm._s(_vm.listaProjetosPesquisa.length > 1 ? 'projetos' : 'projeto') + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('br')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-872456ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/consulta-projetos-pesquisa.vue
// module id = 800
// module chunks = 0